// extracted by mini-css-extract-plugin
export default {"techCheckContainer":"XIOXQnKK_LMAD4pX4uqX","techCheckContent":"GNIAkt16bxjtB4BAWuHs","techCheckControl":"y0gKtklog8DKL55wobur"};